module.exports = function() {
  return new Worker(__webpack_public_path__ + "72bbd6f19720afe9d9bf.worker.js");
};